import { Field } from "react-final-form";
import { FormattedMessage, useIntl } from "react-intl";
import { disabledInputStyles, standardInputStyles, standardTextAreaStyles } from "@/components/common/inputStyles";
import { cn } from "@/lib/utils";

const FormInput = ({ 
  name, 
  type, 
  label, 
  placeholder, 
  isTextArea = false, 
  disabled = false,
  inputType,
  currency = 'AED'
}) => {
  const { formatMessage } = useIntl();

  // Format number with thousands separator
  const formatCurrency = (value) => {
    if (!value) return '';
    // Remove any non-numeric characters except decimal point
    const numericValue = value.toString().replace(/[^\d.]/g, '');
    // Add thousands separator
    return numericValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  // Parse formatted currency back to numeric value
  const parseCurrency = (value) => {
    if (!value) return '';
    return value.replace(/,/g, '');
  };
  
  const renderTextArea = (input) => 
    <textarea
        className={cn(standardTextAreaStyles, disabled && disabledInputStyles)}
        {...input}
        type={type}
        placeholder={placeholder ? formatMessage({ id: placeholder }) : ""}
        rows={4}
        disabled={disabled}
    />;

    const renderNormalInput = (input) => (
      <input
        className={cn(standardInputStyles, disabled && disabledInputStyles, inputType === "currency" ? "pr-12" : "")}
        {...input}
        type={inputType === "currency" ? "text" : type}
        placeholder={placeholder ? formatMessage({ id: placeholder }) : ""}
        disabled={disabled}
      />
    );

  return (
      <Field
        name={name}
        parse={inputType === 'currency' ? parseCurrency : undefined}
        format={inputType === 'currency' ? formatCurrency : undefined}
        render={({ input, meta }) => (
          <div>
            {label && (
              <label className="font-semibold text-sm leading-4 text-gray-500 pl-3 inline-block w-full">
                <FormattedMessage id={label} />
              </label>
            )}
            <div className="relative">
              {isTextArea ? renderTextArea(input) : renderNormalInput(input)}
              {inputType === 'currency' && (
                <div className="absolute inset-y-0 right-0 flex items-center px-3 m-[1px] rounded-r-lg bg-slate-100 pointer-events-none">
                  <span className="text-gray-400 text-sm font-semibold">{currency}</span>
                </div>
              )}
          </div>

          {meta.touched && meta.error && (
            <span className="text-sm text-red-500 pl-3 mt-3">{meta.error}</span>
          )}
        </div>
      )}
    />
  );
};

export default FormInput;
